<template>
  <v-footer
    color="#173347"
    class="footer white--text"
    padless
    absolute
  >
    <v-container class="footer-inner"><div><strong><i>f</i> fintech<span>.</span></strong><small>Inversión colectiva en activos reales.</small></div><p>Demo interna · {{ new Date().getFullYear() }}</p></v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer{min-height:94px!important;font-family:Inter,Arial,sans-serif}.footer-inner{display:flex;align-items:center;justify-content:space-between}.footer strong{font-size:20px;letter-spacing:-1px}.footer strong i{background:#e76f51;border-radius:50%;font-family:Georgia,serif;font-style:normal;font-weight:400;display:inline-flex;align-items:center;justify-content:center;width:23px;height:23px;margin-right:6px}.footer strong span{color:#e76f51}.footer small{display:block;color:#aebfc9;font-size:10px;margin-top:5px}.footer p{font-size:10px;color:#aebfc9;margin:0}@media(max-width:500px){.footer-inner{padding:20px 12px}.footer p{display:none}}
</style>
